import { Controller } from "@hotwired/stimulus"
import { isMobileApp } from "../packs/global/utils"
require('tom-select')

// Connects to data-controller="tom-select"
export default class extends Controller {
  static values = {
    create: { type: Boolean, default: false },
    limit: { type: Number, default: 0 }, // max Anzahl Einträge die dargestellt werden (wären sonst 50)
  }

  connect() {
    if (isMobileApp) {
      // In der mobile App soll kein TomSelect verwendet werden, da die nativen Selects besser aussehen
      // Standard Bootstrap Styling für Selects aktivieren
      this.element.classList.add('form-select')
    } else {
      // Standard Bootstrap Styling für Selects entfernen, da TomSelect das Styling selbst übernimmt
      this.element.classList.remove('form-select')

      this.select = new TomSelect(this.element, this.options)
    }
  }

  disconnect() {
    this.destroy()
  }

  clear() {
    this.select.clear()
  }

  destroy() {
    this.select.destroy()
  }

  get options() {
    const plugins = []

    if (this.isMultiple) {
      plugins.push("remove_button")
    }

    return {
      plugins: plugins,
      create: this.createValue,
      createOnBlur: this.createValue, // erstellt neuen Eintrag, wenn bei Blur etwas eingeippt wurde
      maxOptions: this.limit,
      onItemAdd: function () {
        this.setTextboxValue("") // wenn Textbox nicht geleert wird, bleibt der eingegeben Wert stehen, auch wenn er als Tag hinzugefügt wurde
        if (this.isMultiple) {
          this.refreshOptions() // ohne diese Option bleibt die Auswahl der Option bestehen, dh es werden nicht mehr alle Optionen gesetzt
        }
      },
    }
  }

  get isMultiple() {
    return this.element.multiple
  }
}
